// ЛОГИСТИЧЕН МОДУЛ: ЕКОНТ ХЪБ (ЧИСТ JS СЛУШАТЕЛ)
document.addEventListener("DOMContentLoaded", function() {
  const officeInput = document.getElementById("magoo_selected_office_text");
  const cityInput = document.getElementById("magoo_city");
  const zipInput = document.getElementById("magoo_zip_code");
  const submitBtn = document.getElementById("magooSubmitBtn");

  // Слушател за събития от Message API на Еконт локатора
  window.addEventListener("message", function(event) {
    if (event.origin.includes("econt.com") && event.data && event.data.office !== undefined) {
      const office = event.data.office;
      const name = office.name || "";
      const fullAddress = office.address ? office.address.fullAddress : "";
      const city = (office.address && office.address.city) ? office.address.city.name : "";
      const postCode = (office.address && office.address.city) ? (office.address.city.postCode || "1000") : "1000";

      if (name) {
        // Защита против автомати (APS)
        if (name.includes("APS") || name.includes("Еконтомат") || name.includes("Автомат")) {
          alert("Доставката до автомати не е възможна. Моля, изберете физически офис от списъка на картата!");
          if (officeInput) officeInput.value = "";
          if (cityInput) cityInput.value = "";
          if (submitBtn) submitBtn.disabled = true;
          return;
        }
        
        // Попълване на данните от Еконт в нашия интерфейс
        if (officeInput) officeInput.value = "Еконт: " + name + " (" + fullAddress + ")";
        if (cityInput) cityInput.value = city;
        if (zipInput) zipInput.value = postCode; 
        if (submitBtn) submitBtn.disabled = false;
      }
    }
  }, false);
});